import { AddressExemptionCheckbox } from '@components'

import { ReactElement, useCallback } from 'react'

import { useUpdateAddressExemption } from '@features/contacts/hooks/useUpdateAddressExemption'

import { useMissingCustomerDetailsForm } from '../../../../../../contexts/missingCustomerDetailsFormContext'

export const CustomerAddressExemption = (): ReactElement => {
  const { missingCustomerDetailsForm } = useMissingCustomerDetailsForm()
  const { clearErrors, FormItem, setValue } = missingCustomerDetailsForm
  const { updateAddressExemption } = useUpdateAddressExemption({ setValue })

  const handleAddressExemptionChange = useCallback(
    (isAddressExempt: boolean) => {
      updateAddressExemption(isAddressExempt)

      if (isAddressExempt) {
        clearErrors('address')
      }
    },
    [clearErrors, updateAddressExemption],
  )

  return (
    <FormItem
      name="isAddressExempt"
      render={({ field: { value } }) => (
        <AddressExemptionCheckbox checked={value} onChange={handleAddressExemptionChange} />
      )}
    />
  )
}
